import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SectionHeader } from "@pentabd/ui";

import { InputTextAreaRow, InputTextRow } from "@components";
import { AGREEMENT_FIELDS } from "../..";

export const VendorAuthorizePersonInfo = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        title={t("PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_AUTHORIZED.TITLE")}
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_AUTHORIZED.PERSON_NAME"
        register={{
          ...register(AGREEMENT_FIELDS.VENDOR_AUTHORIZED.PERSON_NAME),
        }}
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_AUTHORIZED.PERSON_EMAIL"
        register={{
          ...register(AGREEMENT_FIELDS.VENDOR_AUTHORIZED.PERSON_EMAIL),
        }}
        error={errors as any}
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_AUTHORIZED.PERSON_DESIGNATION"
        register={{
          ...register(AGREEMENT_FIELDS.VENDOR_AUTHORIZED.PERSON_DESIGNATION),
        }}
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_AUTHORIZED.PERSON_PHONE_NUMBER"
        register={{
          ...register(AGREEMENT_FIELDS.VENDOR_AUTHORIZED.PERSON_PHONE_NUMBER),
        }}
      />

      <InputTextAreaRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_AUTHORIZED.PERSON_DETAILS"
        register={{
          ...register(AGREEMENT_FIELDS.VENDOR_AUTHORIZED.PERSON_DETAILS),
        }}
      />

      {/* <FileRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_AUTHORIZED.DOC_UPLOAD"
        name={AGREEMENT_FIELDS.VENDOR_AUTHORIZED.DOC_UPLOAD}
        control={control}
        setValue={setValue}
        register={register}
      /> */}
    </>
  );
};
